/**
 * Defense-in-depth for the server-validated merchant handoff URL.
 *
 * The backend enforces the deployment allowlist. The browser repeats the
 * structural checks before adding the public InitialToken.
 */

const SENSITIVE_QUERY_PARTS = [
  'token',
  'secret',
  'password',
  'credential',
  'authorization',
  'requestkey',
  'answerkey',
  'initialidentification',
  'cardnumber',
  'securitycode',
  'cvv',
  'cvc',
  'pan',
] as const;

function isLocalHostname(hostname: string): boolean {
  return hostname === 'localhost'
    || hostname === '127.0.0.1'
    || hostname === '[::1]'
    || hostname === '::1';
}

function hasSensitiveQuery(target: URL): boolean {
  for (const key of target.searchParams.keys()) {
    const normalized = key.toLowerCase().replaceAll(/[^a-z0-9]/g, '');
    if (SENSITIVE_QUERY_PARTS.some((part) => normalized.includes(part))) {
      return true;
    }
  }
  return false;
}

export function buildMerchantRedirectUrl(
  rawUrl: string,
  initialToken?: string,
  currentUrl: string = window.location.href,
): URL | null {
  try {
    const current = new URL(currentUrl);
    const target = new URL(rawUrl);
    const localDevelopmentHttp =
      current.protocol === 'http:'
      && isLocalHostname(current.hostname)
      && target.protocol === 'http:'
      && isLocalHostname(target.hostname);
    if (
      target.username
      || target.password
      || target.hash
      || hasSensitiveQuery(target)
      || (
        target.protocol !== 'https:'
        && !localDevelopmentHttp
      )
    ) {
      return null;
    }
    if (initialToken) target.searchParams.set('token', initialToken);
    return target;
  } catch {
    return null;
  }
}
